module.exports = __webpack_public_path__ + "img/slider_15.03b853f3.jpg";